import React, { Component } from "react";
import { PowerSupply, TimerPlayer } from "@learningblocks/storybook-components";

import animation1 from './power_supply_running_animation.json';
import animation2 from './power_supply_running_animation_no_gel.json';
import animation3 from './power_supply_running_animation_no_bands.json';
import animation4 from './power_supply_running_animation_orientation.json';

import TRANSCRIPT_PATH from './sample.srt';

import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../../../toast/Toast'
import colors from  '@learningblocks/protocol-constants/lib/Styles/_colors.scss';

const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px",
        paddingLeft: 0
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  GEL_BOX_OPEN: {
    title: "Gel electrophoresis box lid open!",
    message: "Ensure that the lid of the gel electrophoresis box is closed before running the power supply."
  },
  GEL_BOX_DISCONNECTED: {
    title: "Gel electrophoresis box disconnected!",
    message: "Ensure that the power supply leads are connected on both ends before running the power supply."
  }
};

export class Graphics extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
       frame: 0,
       isPaused: true,
       completed: false,
    }
  }

  animationData = {
    isPath: false,
    animation: animation1,
  };

  onClickPause = () => {
    this.setState({ isPaused: true})
  };

  onClickPlay = () => {
    this.setState({ isPaused: false})
  };

  onPlaybackComplete = () => {
    console.log('running onPlaybackComplete');
    this.onClickPause();
    this.setState({ completed: true })
    this.props.animationPlaybackCompletePs({  id: this.props.id })
  };

  setFrame = (frame) => {
    this.setState({ frame })
  }

  componentDidMount(){
    if (this.state.completed) {
      console.log('in component did mount because completed is true: ');
      this.props.animationPlaybackCompletePs({  id: this.props.id })
      this.setState({completed: false});
    }
  }
  
  checkPluggedIn = () => {
    if (this.props.cables.anode === 'black' && this.props.cables.cathode === 'red')
      return true;
    else return false;
  };

  gelHasSolution = (lanes) => {
    if(
      typeof lanes !== 'undefined' &&
      lanes !== null
    ){
      let laneList = Object.keys(lanes).filter(lane => lanes[lane].empty === false);
      if(laneList.length > 0){
        return true;
      }
    }
    return false;
  }

  getAnimation = () => {
    switch (true) {
      case (!this.props.interactionProps.gelBoxes[0].containsGel):
        return animation2; // No gel
      case (this.gelHasSolution(this.props.interactionProps.agaroseGel[0].lanes) === false && this.props.interactionProps.gelBoxes[0].gelOrientation !== 180):
        return animation3; // No bands & Incorrect orientation
      case (this.props.interactionProps.gelBoxes[0].gelOrientation !== 180):
        return animation4; // Incorrect orientation
      case (this.gelHasSolution(this.props.interactionProps.agaroseGel[0].lanes) === false):
        return animation3; // No bands
      default:
        return animation1; // Correct animation
    }
  }

  render() {
    return (
      <div>
      <PowerSupply
          interactionProps={this.props.interactionProps}
          alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
          id={this.props.id}
          modalOpen={this.props.modalOpen}
          toggleModal={() => this.props.toggleModalPs({  id: this.props.id })}
          power={this.props.power}
          togglePower={() => this.props.togglePowerPs({  id: this.props.id })}
          settingsData={this.props.settings}
          setTimer={(data) => this.props.setTimerPs({data, id: this.props.id})}
          setVoltage={(data) => this.props.setVoltagePs({data, id: this.props.id})}
          setCurrent={(data) => this.props.setCurrentPs({data, id: this.props.id})}
          cablesData={this.props.cables}
          pluggedIn={this.checkPluggedIn()}
          running={this.props.running}
          onClickStart={() => this.props.onStartPowerSupplyPs({  id: this.props.id })}
          onClickStop={() => this.props.onStopPowerSupplyPs({  id: this.props.id })}
          completed={this.props.completed}
          onDropWire={(data) => this.props.onDropWirePs({data, id: this.props.id})}
          lang={'en'}
          // lang={props.lang}
          player={
            <TimerPlayer
              isPaused={this.state.isPaused}
              onClickPause={this.onClickPause}
              onClickPlay={this.onClickPlay}
              currentFrame={this.state.frame}
              onChangeFrame={this.setFrame}
              animationData={{    
                isPath: false,
                animation: this.getAnimation()
              }}
              displayTime={this.props.settings.timer}
              disabled={!this.props.running}
              transcript={TRANSCRIPT_PATH}
              showTranscript={true}
              onComplete={this.onPlaybackComplete}
              tabIndex={'0'}
              // tabIndex={props.tabIndex}
              lang={'en'}
            />
          }
        />

      </div>

    );
  }
}
